<template>
  <div class="sm-latlng">
    {{ displayText }}
  </div>
</template>

<script>
import isNil from 'lodash/isNil';

function getText(num) {
  if (isNil(num)) return '--';
  return num.toFixed(6);
}

export default {
  name: 'Sm3dLatLng',
  data() {
    return {
      sharedState: window.store.state,
      longitude: null,
      latitude: null,
      height: null
    };
  },

  // 监听viewer
  computed: {
    isInitViewer: function() {
      return this.sharedState.isInitViewer;
    },
    displayText: function() {
      return `纬度 ${getText(this.latitude)} 经度 ${
        getText(this.longitude)
      } 高度 ${getText(this.height)}`;
    }
  },
  methods: {
    init() {
      const { Cesium, viewer } = window;
      var handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
      const mouseOverHandler = movement => {
        var ellipsoid = viewer.scene.globe.ellipsoid;
        var cartesian = viewer.camera.pickEllipsoid(
          movement.endPosition,
          ellipsoid
        );
        if (cartesian) {
          //将笛卡尔坐标转换为地理坐标
          var cartographic = ellipsoid.cartesianToCartographic(cartesian);
          //将弧度转为度的十进制度表示
          this.longitude = Cesium.Math.toDegrees(cartographic.longitude);
          this.latitude = Cesium.Math.toDegrees(cartographic.latitude);
          this.height = viewer.scene.globe.getHeight(cartographic);
          //获取高度
          //this.height = Math.ceil(viewer.camera.positionCartographic.height);
        }
      };
      handler.setInputAction(
        mouseOverHandler,
        Cesium.ScreenSpaceEventType.MOUSE_MOVE
      );
    },
    clear() {}
  },
  watch: {
    isInitViewer() {
      this.init();
    }
  }
};
</script>
<style lang="less" scoped>
.sm-latlng {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  margin-bottom: 5px;
  background: rgba(0, 0, 0, 0.3);
  width: 480px;
  color: rgba(204, 204, 204, 0.9);
  padding: 4px;
  font-size: 16px;
  text-align: center;
}
</style>
